<div class="container">
    <div class="forgot-form" *ngIf="mode == 'password'">
        <form [formGroup]="passwordForm" (ngSubmit)="onChangePassword()">

            <h2 class="text-left">Change your password</h2>
            <div class="form-group">
                <label for="inputPassword1">Password</label>
                <input formControlName="password" pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$" type="password" class="form-control" id="inputPassword1" placeholder="">
                <small id="password1Help" class="form-text text-muted" *ngIf="passwordForm.controls['password'].invalid">Your password should include both <strong>upper</strong> and <strong>lower</strong> case characters, a <strong>number</strong> or <strong>special character</strong>, and be a minimum of <strong>8 characters long</strong>.</small>
            </div>
            <div class="form-group">
                <label for="inputPassword2">Password Confirm</label>
                <input formControlName="passwordConfirm" type="password" class="form-control" id="inputPassword2" placeholder="">
                <small id="password2Help" class="form-text text-danger" *ngIf="(passwordForm.value.passwordConfirm.length >= passwordForm.value.password.length) && (passwordForm.value.password !== passwordForm.value.passwordConfirm)">Your passwords do not match.</small>
            </div>

            <div class="alert alert-danger" *ngIf="errorMessage">
                {{errorMessage}}
            </div>
            <div class="row" style="margin-top: 40px;">
                <div class="col-12">
                    <button type="submit" mat-raised-button [disabled]="!passwordForm.valid  || (passwordForm.value.password !== passwordForm.value.passwordConfirm) || submitting">{{submitButtonText}}</button>
                </div>
            </div>
        </form>
    </div>

    <div class="alert alert-info" *ngIf="mode == 'done'">
        Your password has been successfully changed.
    </div>
</div>


